import React from "react";
import h1 from "../../assets/images/resume1.svg";
import h2 from "../../assets/images/resume2.svg";
import h3 from "../../assets/images/resume3.svg";
import h4 from "../../assets/images/resume4.svg";
import h5 from "../../assets/images/resume5.svg";

const pills = [
  { icon: h1, label: "SOP Writing" },
  { icon: h2, label: "SOP Customization" },
  { icon: h3, label: "SOP Proofreading" },
  { icon: h4, label: "High-Quality SOPs" },
  { icon: h5, label: "We're Fast" },
];

function Help1() {
  return (
    <section className="layout-section text-center">
      <div className="layout-container">
        <h1 id="heading-large">Professional Writing Services by Ever Sky</h1>
        <p className="max-w-2xl mx-auto mt-4 text-gray-600">
          Our professional SOP writers create first-class artefacts that place
          you high in the candidate pool.
        </p>
        <div className="w-full flex flex-wrap gap-3 sm:gap-4 items-center justify-center my-8">
          {pills.map((pill) => (
            <div
              key={pill.label}
              className="flex items-center gap-2 px-4 py-2 bg-white shadow-md rounded-full text-sm sm:text-base"
            >
              <img alt="" className="w-6 h-6" src={pill.icon} />
              {pill.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Help1;
